import React from 'react';
import { LogIn } from 'react-feather';
import man from '../../../assets/images/dashboard/profile.png';
import { LI, UL, Image, P } from '../../../AbstractElements';
import { useProspectAuth } from '../../../Auth/ProspectAuthContext';
import { useNavigate } from 'react-router-dom';

const UserHeader = () => {
  const { user, logout } = useProspectAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <li className='profile-nav onhover-dropdown pe-0 py-0'>
      <div className='media profile-media'>
        <Image attrImage={{ className: 'b-r-10 m-0', src: man, alt: '' }} />
        <div className='media-body'>
          <span>{user?.name || user?.email || 'Usuário'}</span>
          <P attrPara={{ className: 'mb-0 font-roboto' }}>
            {user?.role === 'admin' ? 'Admin' : 'Cliente'} <i className='middle fa fa-angle-down'></i>
          </P>
        </div>
      </div>
      <UL attrUL={{ className: 'simple-list profile-dropdown onhover-show-div' }}>
        <LI attrLI={{ onClick: handleLogout }}>
          <LogIn />
          <span>Sair</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
